import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Loader from "../../../components/loader";
import AdminLayout from "../../../layouts/AdminLayout";
import { useDispatch, useSelector } from "react-redux";
import { fetchBootcampDetails } from "../../../redux/features/admin/actions/authAction";
import moment from "moment";
import BootcampPage from "../../../components/Modals/common/bootcamp/BootcampPage";


const BootcampDetail = () => {
  const dispatch = useDispatch();
  const id = useLocation()?.state?.id || "";
  const paginatedList = useLocation()?.state?.data || []
  const { isLoading, bootCampData } = useSelector((state) => state.admin.auth);
  const [currentId, setCurrentId] = useState(id);
  const [updateBootCampData, setUpdateBootCampData] = useState(bootCampData ?? {})

  useEffect(() => {
    dispatch(fetchBootcampDetails({ payload: id }));
  }, []);

  useEffect(() => {
    setUpdateBootCampData(bootCampData ?? {})
  }, [bootCampData]);

  const handleClickNext = () => {
    if (!paginatedList || paginatedList.length === 0) return;
    const currentIndex = paginatedList.findIndex(
      (item) => item.bootcamp_id === currentId
    );
    const nextIndex = (currentIndex + 1) % paginatedList.length;
    const nextItem = paginatedList[nextIndex];
    setUpdateBootCampData(nextItem);
    setCurrentId(nextItem.bootcamp_id);
  };

  const handleClickPrevious = () => {
    if (!paginatedList || paginatedList.length === 0) return;
    const currentIndex = paginatedList.findIndex(
      (item) => item.bootcamp_id === currentId
    );
    const prevIndex =
      (currentIndex - 1 + paginatedList.length) % paginatedList.length;
    const prevItem = paginatedList[prevIndex];
    setUpdateBootCampData(prevItem);
    setCurrentId(prevItem.bootcamp_id);
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <AdminLayout>
      <BootcampPage bootCampData={updateBootCampData} handleClickNext={handleClickNext} handleClickPrevious={handleClickPrevious} />
    </AdminLayout>
  );
};

export default BootcampDetail;
